module.exports = __webpack_public_path__ + "e8234a71725389dfa58779b0473e0d08.svg";